export const FLAG_TYPE_SUCCESS = 'success';
export const FLAG_TYPE_ERROR = 'error';
export const FLAG_TYPE_INFO = 'info';
export const FLAG_TYPE_WARNING = 'warning';
export let TilesVariation = /*#__PURE__*/function (TilesVariation) {
  TilesVariation["LARGE"] = "LARGE";
  TilesVariation["SMALL"] = "SMALL";
  return TilesVariation;
}({});
export let HighlightedSectionVariation = /*#__PURE__*/function (HighlightedSectionVariation) {
  HighlightedSectionVariation["PROMINENT"] = "PROMINENT";
  return HighlightedSectionVariation;
}({});
export let ProductMarketingGroupType = /*#__PURE__*/function (ProductMarketingGroupType) {
  ProductMarketingGroupType["COLLECTION"] = "COLLECTION";
  ProductMarketingGroupType["CATEGORY"] = "CATEGORY";
  return ProductMarketingGroupType;
}({});